











import { Component, Ref, Vue } from 'vue-property-decorator';
import Start from '@/components/Start.vue';
import IntroNav from '@/components/IntroNav.vue';
import ProductIntro from '@/components/ProductIntro.vue';
import TeamIntro from '@/components/TeamIntro.vue';
import JoinUs from '@/components/JoinUs.vue';
import ContactUs from '@/components/ContactUs.vue';

@Component({
  components: {
    Start,
    IntroNav,
    ProductIntro,
    TeamIntro,
    JoinUs,
    ContactUs,
  },
  mounted() {
    window.addEventListener('scroll', () => { this.$forceUpdate(); }, true);
  },
})
export default class App extends Vue {
  @Ref('product-intro')
  private readonly productIntro!: ProductIntro;
  @Ref('team-intro')
  private readonly teamIntro!: TeamIntro;
  @Ref('join-us')
  private readonly joinUs!: JoinUs;
  @Ref('contact-us')
  private readonly contactUs!: ContactUs;

  public activeItem(): string {
    const introKeys: string[] = ['', '产品介绍', '团队介绍', '加入我们', '联系我们'];
    const introComp: Vue[] = [this.productIntro, this.teamIntro, this.joinUs, this.contactUs];
    let i = 0;
    while (i < introKeys.length - 1) {
      if (!introComp[i] || introComp[i].$el.getBoundingClientRect().top >= 70) {
        break;
      }
      i++;
    }
    return introKeys[i];
  }
}
